import { userStore } from "../ducks/user";
import { wsConnectionStore } from "../ducks/wsConnection";
import { connectToWebSocket, useLongPolling } from "./websocket";
import { routeIncommingMessage } from "./wsInRoutes";
import { GamePlayWs } from "./wsOutRoutes";

export async function longPollingGetRequest(
  username: string,
  sessionId: string,
  gameId: string
) {
  const { longPollingUrl } = wsConnectionStore.getState();

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 10000); // cancel after 10s

  try {
    const response = await fetch(
      `${longPollingUrl}/long-polling?username=${username}&sessionId=${sessionId}&gameId=${gameId}`,
      { signal: controller.signal }
    );

    clearTimeout(timeout);

    if (!response.ok) {
      console.log("error", response.status);
      connectToWebSocket();
      return;
    }

    const data = await response.json();

    if (data?.error) {
      connectToWebSocket();
      return;
    }

    if (data?.cmd && data.cmd != "NO_DATA") {
      routeIncommingMessage(data);
    }

    if (useLongPolling) {
      import("../ducks/gamePlay").then(async ({ gamePlayStore }) => {
        const { gameId } = gamePlayStore.getState();
        longPollingGetRequest(username, sessionId, gameId);
      });
    }

    if (data?.cmd == "NO_DATA") {
      setTimeout(() => {
        import("../ducks/gamePlay").then(({ gamePlayStore }) => {
          const { gameId, turns, moves } = gamePlayStore.getState();
          GamePlayWs.sendGameSync(gameId, turns, moves);
        });
      }, 200);
    }
  } catch (e) {
    clearTimeout(timeout);
    if (e.name === "AbortError") {
      console.warn("Request timed out. Retrying...");
    } else {
      console.error("Fetch error", e);
    }

    // Retry immediately if it failed or timed out
    setTimeout(() => {
      longPollingGetRequest(username, sessionId, gameId);
    }, 1000);
  }
}

export async function longPollingPostRequest(message: object) {
  const username = userStore.getState().username;
  const sessionId = sessionStorage.getItem("sessionId");
  const { longPollingUrl } = wsConnectionStore.getState();
  try {
    const response = await fetch(`${longPollingUrl}/command`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username,
        sessionId,
        message,
      }),
    });

    if (!response.ok) {
      return;
    }
  } catch (e) {
    console.log(e);
  }
}
